/* global axios */
import ApiClient from '../ApiClient';

// Teletel Flows endpoints (Phase 1). Everything lives under /teletel; the
// server-side engine gate and admin authorization are authoritative - this
// client only mirrors them.
class TeletelFlowsAPI extends ApiClient {
  constructor() {
    super('flows', { accountScoped: true });
  }

  baseUrl() {
    return `/teletel${super.baseUrl()}`;
  }

  exportDefinitions() {
    return axios.get(`${this.url}/export`);
  }

  previewImport(payload) {
    return axios.post(`${this.url}/import_preview`, { payload });
  }

  importDefinitions(payload) {
    return axios.post(`${this.url}/import`, { payload });
  }

  publish(flowId) {
    return axios.post(`${this.url}/${flowId}/publish`);
  }

  deactivate(flowId) {
    return axios.post(`${this.url}/${flowId}/deactivate`);
  }

  // One operation UUID per submission attempt chain (owner decision,
  // architecture revision 3): callers generate it when the operation starts
  // and reuse it verbatim on retries.
  trigger(flowId, { conversationDisplayId, operationUuid }) {
    return axios.post(`${this.url}/${flowId}/trigger`, {
      conversation_id: conversationDisplayId,
      operation_uuid: operationUuid,
    });
  }

  runsUrl() {
    return this.url.replace(/\/flows$/, '/flow_runs');
  }

  getRuns(params = {}) {
    return axios.get(this.runsUrl(), { params });
  }

  getRun(runId) {
    return axios.get(`${this.runsUrl()}/${runId}`);
  }

  stopRun(runId) {
    return axios.post(`${this.runsUrl()}/${runId}/stop`);
  }

  resumeRun(runId) {
    return axios.post(`${this.runsUrl()}/${runId}/resume`);
  }

  pauseRun(runId) {
    return axios.post(`${this.runsUrl()}/${runId}/pause`);
  }

  retryRun(runId) {
    return axios.post(`${this.runsUrl()}/${runId}/retry`);
  }

  getAvailable() {
    return axios.get(`${this.url}/available`);
  }

  getAttachments() {
    return axios.get(`${this.url}/attachments`);
  }

  templatesUrl() {
    return this.url.replace(/\/flows$/, '/flow_templates');
  }

  getTemplates() {
    return axios.get(this.templatesUrl());
  }

  getTemplate(templateId) {
    return axios.get(`${this.templatesUrl()}/${templateId}`);
  }

  instantiateTemplate(templateId, name) {
    return axios.post(`${this.templatesUrl()}/${templateId}/instantiate`, {
      name,
    });
  }

  enginesUrl() {
    return this.url.replace(/\/flows$/, '/flow_inbox_engines');
  }

  getEngines() {
    return axios.get(this.enginesUrl());
  }

  updateEngine(inboxId, engine) {
    return axios.put(this.enginesUrl(), { inbox_id: inboxId, engine });
  }
}

export default new TeletelFlowsAPI();
